import React from "react";

import "./Input.css";

export default function InputRange({
  title,
  value,
  handleChange,
  min,
  max,
  step,
}) {
  return (
    <div className="input-range">
      <div className="input-range-title">
        {title}: {value}
      </div>

      <div className="input-range-value">
        <span> {min} </span>
        <input
          type="range"
          value={value}
          onChange={(event) => handleChange(event.target.value)}
          min={min}
          max={max}
          step={step ? step : 1}
        />
        <span> {max} </span>
      </div>
    </div>
  );
}
